import React, { useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  Dialog as MuiDialog,
  DialogContent,
  DialogTitle as MuiDialogTitle,
  DialogActions,
  Button,
} from '@material-ui/core';

import { eventStatusOptions } from '../../configs/events';
import useMainContext from '../../hooks/useMainContext';
import useDiaryData from '../../hooks/useDiaryData';
import useSnackbarText from '../../hooks/useSnackbarText';
import Checkbox from '../Checkbox';
import events from '../../api/events';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 0,
    paddingLeft: 22,
  },
  closeButton: {
    alignSelf: 'flex-start',
    //color: theme.palette.secondary.main,
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, title, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography color="primary" variant="h6">
        {title}
      </Typography>
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    maxWidth: 300,
    transition: 'all 0.5s',
    [theme.breakpoints.down('xs')]: {
      margin: 10,
    },
  },
  checkboxWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  checkbox: {
    margin: 0,
  },
}));

export default function Dialog() {
  const classes = useStyles();
  const [disabled, setDisabled] = useState(false);
  // eslint-disable-next-line
  const [diary, _, handleSetDate, handleManualFetch] = useDiaryData();
  const handleSnackbarChange = useSnackbarText();
  const {
    eventStatusUpdate,
    onEventStatusUpdate,
    handleChange: handleMainContextChange,
  } = useMainContext();
  const [status, setStatus] = useState(
    eventStatusUpdate ? eventStatusUpdate.status : ''
  );

  const handleClose = () => {
    handleMainContextChange({ eventStatusUpdate: null });
  };

  const handleChange = statusID => () => {
    const statusArray = status.split(',');
    const statusIndex = statusArray.indexOf(String(statusID));
    if (statusIndex === -1) {
      statusArray.push(statusID);
    } else {
      statusArray.splice(statusIndex, 1);
      if (!statusArray.length) {
        statusArray.push('0');
      }
    }
    setStatus(statusArray.join(','));
  };

  const isChecked = statusID => {
    return status.split(',').includes(String(statusID));
  };

  const handleUpdate = async () => {
    const payload = {
      eventID: eventStatusUpdate.eventID,
      selectedStartDate: eventStatusUpdate.selectedStartDate,
      exceptionID: eventStatusUpdate.exceptionID,
      status: status,
      startAt: eventStatusUpdate.currentPeriodStartAt,
      endAt: eventStatusUpdate.currentPeriodEndAt,
    };

    setDisabled(true);
    const { data, success } = await events.updateEventStatus(payload);
    setDisabled(false);
    if (success) {
      handleSnackbarChange({ text: 'Status Updated', variant: 'success' });
      if (onEventStatusUpdate) {
        onEventStatusUpdate();
      }
      handleMainContextChange({
        eventStatusUpdate: null,
        onEventStatusUpdate: null,
      });
      handleManualFetch();
    } else {
      handleSnackbarChange({ text: data.message, variant: 'error' });
    }
  };

  useEffect(() => {
    if (eventStatusUpdate) {
      setStatus(eventStatusUpdate.status);
    } else setStatus('');
  }, [eventStatusUpdate]);

  return (
    <div>
      <MuiDialog
        onClose={handleClose}
        aria-labelledby="dialog-title"
        open={Boolean(eventStatusUpdate)}
        classes={{ paper: classes.paper }}
      >
        <DialogTitle
          id="dialog-title"
          onClose={handleClose}
          title={`Activities of ${
            eventStatusUpdate ? eventStatusUpdate.name : ''
          }`}
        />
        <DialogContent>
          <div className={classes.checkboxWrapper}>
            {eventStatusOptions
              // disable `Non Face To Face`
              .filter(option => option.value !== '12')
              .map(e => (
                <Checkbox
                  key={e.value}
                  className={classes.checkbox}
                  label={e.label}
                  value={isChecked(e.value)}
                  onChange={handleChange(e.value)}
                />
              ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleUpdate}
            color="primary"
            variant="contained"
            fullWidth
            disabled={disabled}
          >
            OK
          </Button>
        </DialogActions>
      </MuiDialog>
    </div>
  );
}
